import React from "react";
import { FaPlus } from "react-icons/fa";
import { SortEndHandler } from "react-sortable-hoc";

import { ExerciseWrapper } from "../ExerciseWrapper";
import { AddNewList, AddNewListText } from "./ListItemsExercisePart.styles";
import { SortableListItems } from "./SortableListItems";
import { IListItemsExercisePartProps } from "./types";

export const ListItemsExercisePartComponent: React.FC<IListItemsExercisePartProps> = (
  props: IListItemsExercisePartProps
) => {
  const { addListItem, currentLocale, exercisePart, isEditing, partOperations, sortPartRequest } = props;

  const addList = () => {
    addListItem({ exercise: exercisePart });
  };

  const sortAnswers: SortEndHandler = sort => {
    if (sort.oldIndex !== sort.newIndex) {
      sortPartRequest({
        from: sort.oldIndex,
        itemId: exercisePart.id,
        to: sort.newIndex,
      });
    }
  };

  return (
    <ExerciseWrapper
      currentLocale={currentLocale}
      edit={isEditing}
      exercisePart={exercisePart}
      partOperations={partOperations}
    >
      <SortableListItems {...props} lockAxis="y" onSortEnd={sortAnswers} useDragHandle={true} />

      {isEditing && (
        <AddNewList onClick={addList}>
          <FaPlus />
          <AddNewListText>Click to add a List</AddNewListText>
        </AddNewList>
      )}
    </ExerciseWrapper>
  );
};
